import React from 'react';
import './../Style/YearTopic.css';
import { Link } from 'react-router-dom';
import TopHeader from '../../home/TopHeader';
import TopNavbar from '../../home/TopNavbar';

function PreviousYearMockTest() {

    const pageTitleText = "NEET Previous Year Questions (PYQ) Mock Tests";

    return (
        <>

            <div className="subject-page">

                <TopNavbar name={pageTitleText} />
                <TopHeader name={pageTitleText} />

                <div className="subject-categories">
                    <Link to={`/quiz-year/${"previousyearquestions"}/${"atoz"}/${"atoz"}/${"Full  "}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                Δ
                            </div>
                            <h2>Full  Mock Test  ➔</h2>
                        </div>

                    </Link>

                    <Link to={`/quiz-year/${"previousyearquestions"}/${"physics"}/${"atoz"}/${"Physics"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚛
                            </div>
                            <h2>Physics  ➔</h2>
                        </div>

                    </Link>

                    <Link to={`/quiz-year/${"previousyearquestions"}/${"chemistry"}/${"atoz"}/${"Chemistry"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                ⚗
                            </div>
                            <h2>Chemistry  ➔ </h2>
                        </div>

                    </Link>

                    <Link to={`/quiz-year/${"previousyearquestions"}/${"biology"}/${"atoz"}/${"Biology"}`}
                        className="subject-card"
                        style={{ borderLeft: `5px solid green` }}
                    >
                        <div className="subject-card-header">
                            <div className="subject-icon" style={{ color: "blue" }}>
                                🧬
                            </div>
                            <h2>Biology  ➔ </h2>
                        </div>

                    </Link>
                </div>
            </div>
        </>
    );
}

export default PreviousYearMockTest;